import { FC } from 'react';
import { Col, Row } from 'reactstrap';

import { Card } from 'Elements';

export const SkeletonRequestDecoration: FC = () => {
	// Skeleton style
	const skeletonStyle: React.CSSProperties = {
		minHeight: '1em'
	};

	return (
		<Card>
			<Row>
				<Col md={4} className="mb-3 mb-md-0">
					<div className="d-flex align-items-center gap-3">
						<div className="flex-grow-1 d-flex flex-column gap-2">
							<h6 className="fs-base fw-400 lh-1 mb-0">
								<span
									className="skeletonStyle"
									style={{ ...skeletonStyle, width: 80 }}>
									&nbsp;
								</span>
							</h6>
							<span className="text-gray-3 lh-base">
								<span
									className="skeletonStyle"
									style={{ ...skeletonStyle, width: 80 }}>
									&nbsp;
								</span>
							</span>
							<div className="d-flex">
								<span
									className="skeletonStyle"
									style={{ ...skeletonStyle, width: 80 }}>
									&nbsp;
								</span>
							</div>
						</div>
					</div>
				</Col>
				<Col md={8}>
					<Row>
						<Col
							md={8}
							xl={9}
							className="mb-3 mb-md-0 text-truncate">
							<div className="d-flex pt-2 flex-column">
								<div className="d-flex align-items-center lh-base me-2 mb-2">
									<span className="text-gray-3">
										<span
											className="skeletonStyle"
											style={{
												...skeletonStyle,
												width: 100
											}}>
											&nbsp;
										</span>
									</span>
									<span className="ms-1 text-gray-5">
										<span
											className="skeletonStyle"
											style={{
												...skeletonStyle,
												width: 100
											}}>
											&nbsp;
										</span>
									</span>
								</div>
								<div className="d-flex align-items-center lh-base">
									<span
										className="skeletonStyle"
										style={{
											...skeletonStyle,
											width: 100
										}}>
										&nbsp;
									</span>
									<span className="ms-1 text-gray-5">
										<span
											className="skeletonStyle"
											style={{
												...skeletonStyle,
												width: 100
											}}>
											&nbsp;
										</span>
									</span>
								</div>
							</div>
						</Col>
					</Row>
				</Col>
			</Row>
		</Card>
	);
};
